/**
 * HubReportCard — 학습(/students-hub) 활동 피드의 "리포트 카드"(우측 말풍선)
 *
 * 기존 HubReportList 내부 ReportCard 를 활동 피드(HubActivityFeed)에서 재사용하기 위해 분리.
 *   - 카드 클릭 → onOpenReport(report): 상위가 HubReportModal 을 연다.
 *   - 휴지통  → onDeleteReport(report): 상위가 v2 삭제 후 목록 갱신.
 *
 * v2 리포트 엔트리: { report_id, report_uuid, created_at, meta:{ select:{ concept_ids } } }
 */

import { FileText, ChevronRight, Trash2, Loader2, Link2 } from 'lucide-react';
import V2DateTime from '../common/V2DateTime';
import { shareDdayLabel, shareViewsRemaining } from './shareApi';

const HubReportCard = ({ report, share = null, onOpenReport, onDeleteReport, deleting = false }) => {
  const conceptIds = report?.meta?.select?.concept_ids || [];
  const scopeLabel = conceptIds.length ? `개념 ${conceptIds.length}개` : '전체';

  return (
    <div
      onClick={() => onOpenReport(report)}
      className="group flex cursor-pointer items-center justify-between gap-2 rounded-2xl border border-gray-200 bg-white p-2.5 shadow-sm transition-all duration-300 hover:scale-[1.02] hover:border-primary/20 hover:shadow-2xl"
    >
      <div className="flex min-w-0 items-center gap-2">
        <FileText size={20} className="shrink-0 text-primary" />
        <div className="min-w-0">
          <div className="flex items-center gap-1.5">
            <h3 className="truncate text-[12px] font-semibold">KY Report</h3>
            <span className="shrink-0 rounded-full bg-primary/10 px-1.5 py-0.5 text-[9px] font-bold text-primary">
              {scopeLabel}
            </span>
            {share && (
              <span
                className="inline-flex shrink-0 items-center gap-0.5 rounded-full bg-emerald-50 px-1.5 py-0.5 text-[9px] font-bold text-emerald-700"
                title={`공유 링크 유효 — 잔여 ${shareViewsRemaining(share)}회 · ${shareDdayLabel(share)}`}
              >
                <Link2 size={9} strokeWidth={2.5} />
                {shareDdayLabel(share)} · {shareViewsRemaining(share)}회
              </span>
            )}
          </div>
          <p className="truncate text-[10px] text-gray-500">
            #{report.report_id} · <V2DateTime value={report.created_at} format="dateTimeDot" fallback="-" />
          </p>
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); if (!deleting) onDeleteReport(report); }}
          disabled={deleting}
          title={deleting ? '삭제 중...' : '리포트 삭제'}
          className="rounded-full p-1 text-gray-300 transition-colors hover:bg-danger/10 hover:text-danger disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-transparent disabled:hover:text-gray-300"
        >
          {deleting ? <Loader2 size={13} className="animate-spin" /> : <Trash2 size={13} />}
        </button>
        <ChevronRight size={14} className="text-gray-300 transition-colors group-hover:text-primary" />
      </div>
    </div>
  );
};

export default HubReportCard;
